import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, IMAGES } from '@/core';

export const usePostImage = ({
  onSuccess,
  onError,
}: {
  onSuccess: ({ id }: { id: number }) => void;
  onError?: () => void;
}) => {
  return useMutation({
    mutationFn: (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      return axiosInstance.post(`${ADMIN_API_URL_SUBPATH}/${IMAGES}/upload`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    },
    onSuccess: (data: AxiosResponse<{ id: number }>) => {
      onSuccess(data.data);
    },
    onError: () => onError && onError(),
  });
};
